// TCAS-YEAR
const COLLECTION_NAME = 'tcas-admission-65';

class AdmissionDetails {
  constructor(firebase, userId) {
    this._firebase = firebase;
    this._userId = userId;
    this.initFirebase();
  }

  initFirebase() {
    this._db = this._firebase.firestore();
    this._doc = this._db.collection(COLLECTION_NAME).doc(this._userId);
  }

  unsubscribeListerner() {
    if (this._unsubscribe) this._unsubscribe();
  }

  listenOnUpdate(listener = () => {}) {
    this._unsubscribe = this._doc.onSnapshot(doc => {
      const source = doc.metadata.hasPendingWrites ? 'Local' : 'Server';
      listener(source, doc.data());
    });
  }

  createData = (data = {}) => {
    this._doc.set({
      ...data,
      createdAt: new Date().toUTCString(),
    });
  };

  updateData = (data = {}) => {
    this._doc.update({
      ...data,
      updatedAt: new Date().toUTCString(),
    });
  };

  deleteData = () => {
    this._doc.delete();
  };
}

export default AdmissionDetails;
